import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

const Breadcrumb = () => {
  const location = useLocation();
  const { hasPermissions } = useRequiredAuth();
  return (
    <>
      <div className="d-flex bread-crumb align-items-center flex-wrap">
        <>
          {/* <HorizontalRuleIcon className="rotated" /> */}
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to={{
              pathname: "/voting/groups",
            }}
            className={`  px-1 rounded  ${
              location.pathname.includes("/voting/groups") ? "active" : " "
            }`}
          >
            <span className="text-truncate  menu-item">Groups</span>
          </Link>
        </>

        <>
          <HorizontalRuleIcon className="rotated" />
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to={{
              pathname: "/voting/departments",
            }}
            className={`  px-1 rounded  ${
              location.pathname.includes("/voting/departments")
                ? "active"
                : " "
            }`}
          >
            <span className="text-truncate  menu-item">Department Scores</span>
          </Link>
        </>
        <>
          <HorizontalRuleIcon className="rotated" />
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to={{
              pathname: "/voting/management/highest-scores",
            }}
            className={`  px-1 rounded  ${
              location.pathname.includes("/voting/management/highest-scores")
                ? "active"
                : " "
            }`}
          >
            <span className="text-truncate  menu-item">Management Scores</span>
          </Link>
        </>
        {/* <>
          <HorizontalRuleIcon className="rotated" />
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to={{
              pathname: "/discipline/dashboard",
              state: { statusCode: "DASHBOARD" },
            }}
            className={`  px-1 rounded  ${
              location.pathname.includes("/discipline/dashboard")
                ? "active"
                : " "
            }`}
          >
            <span className="text-truncate  menu-item">Dashboard</span>
          </Link>
        </> */}
      </div>
    </>
  );
};

export default Breadcrumb;
